/**
 * Cabeçalho padrão das páginas de relatório: ícone + título + descrição,
 * com espaço à direita para ações (filtros de período, exportar, etc.).
 */
const CabecalhoRelatorio = ({ icone: Icone, titulo, descricao, acoes }) => (
  <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6">
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div className="flex items-start gap-4">
        {Icone && (
          <div className="w-12 h-12 rounded-xl bg-brand-green bg-opacity-10 text-brand-green flex items-center justify-center shrink-0">
            <Icone size={24} />
          </div>
        )}
        <div>
          <h1 className="text-2xl font-bold text-gray-800">{titulo}</h1>
          {descricao && <p className="text-gray-500 text-sm mt-1">{descricao}</p>}
        </div>
      </div>
      {acoes && (
        <div className="flex flex-wrap items-center gap-2">{acoes}</div>
      )}
    </div>
  </div>
);

export default CabecalhoRelatorio;
